export default "__VITE_ASSET__4a29dad1__"